/** ContractorIntakeRoute — skin-aware switcher for /contractor-intake. */
import { useUISkin } from "@/data/UISkinContext";
import ContractorIntake from "./ContractorIntake";
import ContractorIntakeCockpit from "./ContractorIntakeCockpit";

export default function ContractorIntakeRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <ContractorIntakeCockpit />;
  return <ContractorIntake />;
}
